import './App.css';
import Header from './header/Header';
import Shop from './shopBody/Shop';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Shop></Shop>
    </div>
  );
}

export default App;
